export var reload = function reload() {
  return window.location.reload();
};